export default "__VITE_ASSET__DKesYZIb__"